function lowerFirst(value) {
  return typeof value !== "string" ? "" : value.charAt(0).toLowerCase() + value.slice(1);
}

export { lowerFirst };
//# sourceMappingURL=lower-first.js.map
